/**
 * 전역 UI 줌 스토어
 *
 * @params none
 * @return zoomLevel(%) , setZoomLevel(level), loadFromStorage()
 * @author utis
 * @see    localStorage('viewportZoomLevel')
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

const KEY = 'viewportZoomLevel'

export const useUiZoomStore = defineStore('uiZoom', () => {
    const zoomLevel = ref<number>(100)
    const nonLoadedTranslate = ref(true)

    /**
     * 배율 저장/적용(상태만)
     *
     * @params level 배율(%)
     * @return void
     * @author utis
     * @see    localStorage
     */
    const setZoomLevel = (level: number): void => {
        zoomLevel.value = level
        try { localStorage.setItem(KEY, String(level)) } catch {}
    }

    /**
     * 저장값 로드
     *
     * @params none
     * @return number 로드된 배율(%), 없으면 100
     * @author utis
     * @see    localStorage
     */
    const loadFromStorage = (): number => {
        const raw = typeof window !== 'undefined' ? localStorage.getItem(KEY) : null
        const val = Math.round(Number(raw ?? 100))
        const safe = isNaN(val) ? 100 : Math.min(200, Math.max(50, val))
        zoomLevel.value = safe
        return safe
    }

    return { zoomLevel, nonLoadedTranslate, setZoomLevel, loadFromStorage }
})
